<template>
  <a-modal
    title="微信配置"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }"
                    ref="ruleForm"
                    :rules="rules"
      >
        <a-form-model-item
          prop="wechat"
          label="是否开启微信">
          <a-radio-group v-model="model.wechat" >
            <a-radio-button value="1">
              是
            </a-radio-button>
            <a-radio-button value="0">
              否
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          prop="wechat"
          v-if="model.wechat==='1'"
          label="选择微信">
          <a-select
          placeholder="请选择"

          v-model="model.wechatId"
          :filterOption="filterOption"
        >
          <a-select-option :value="item.id" v-for="item in wechatList">{{item.name}}</a-select-option>
        </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction,putAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  export default {
    name: 'WechatConfig',
    data(){
      return {
        rules:{},
        confirmLoading:false,
        visible:false,
        model:{},
        wechatList:[],
      }
    },
    methods:{
      view(project){
        this.model = Object.assign({},project)
        console.log(this.model)
        this.visible = true
        getAction('/management/wechatConfig/listAll').then(res=>{
          if(res.success){
            this.wechatList = res.result
          }
        })
      },
      handleOk(){
        putAction('/management/project/editWechat',this.model).then(res=>{
          if(res.success){
            this.wechatList = res.result
            this.$message.success(res.message)
            this.$emit('ok')
            this.handleCancel()
          }
        })

      },
      handleCancel(){
        this.visible = false
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped>

</style>